import { ITooManyRequestsRetryConfig } from '@app/core/interceptors/queue-requests-interceptor/interfaces/too-many-requests-retry-config.interface';

/** Automatic `429` retry of the global http queue (see `http-queue.service.ts`). Internal to the queue. */
export const TOO_MANY_REQUESTS_RETRY_CONFIG: ITooManyRequestsRetryConfig = {
  delayMs: 1000,
  maxRetries: 5,
};
